import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcActivity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path
        d="M8 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm20 1v2H16v-2h12Zm0-10v2H16v-2h12Zm0-10v2H16V5h12Z"
        id="Ic_activity_svg__a"
      />
    </defs>
    <use
      fill="currentColor"
      xlinkHref="#Ic_activity_svg__a"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcActivity;
